// src/components/home/MoreColors.jsx

'use client'

import { useState } from 'react';
import { useRouter } from 'next/navigation';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';
import { capitalize } from '@/lib/functions.utils';


export default function MoreColors({ lang, remainingColors, label }) {

  const [selectedColor, setSelectedColor] = useState('');
  const router = useRouter();

  const handleChange = (event) => {
    setSelectedColor(event.target.value);
    router.push(`/${lang}/shop/carpets?mainColors=${event.target.value}`);
  };

  return (
    <FormControl sx={{ minWidth: 200 }} style={{textAlign: 'start'}}>
      <InputLabel id={'more-colors'}>{label}</InputLabel>
      <Select
        labelId={'more-colors'}
        value={selectedColor}
        label={label}
        onChange={handleChange}
        variant="outlined"
      >
        { remainingColors.map(color => (
          <MenuItem key={color.key} value={color.name['en']}>{capitalize(color.name[lang])}</MenuItem>
        )) }
      </Select>
    </FormControl>
  );
}
